export default "__VITE_ASSET__C77jrs0V__"